// Personal notification-channels strings (shared portal + operator; auto-merged
// by lib/i18n.ts).
export const en = {
  'ds.channels.title': 'Notification channels',
  'ds.channels.subtitle':
    'Choose how you get notified. Email is on by default — turn it off, or add your own Teams, Slack or webhook.',
  'ds.channels.add': 'Add channel',
  'ds.channels.email_title': 'Email',
  'ds.channels.inbox_note':
    'The in-app inbox is always on. Email and any channels you add are notified on top of it.',
  'ds.channels.channel.email': 'Email',
  'ds.channels.channel.teams': 'Microsoft Teams',
  'ds.channels.channel.slack': 'Slack',
  'ds.channels.channel.webhook': 'Webhook',
  'ds.channels.on': 'Enabled',
  'ds.channels.off': 'Disabled',
  'ds.channels.enable': 'Enable',
  'ds.channels.disable': 'Disable',
  'ds.channels.test': 'Test',
  'ds.channels.edit': 'Edit channel',
  'ds.channels.remove': 'Remove channel',
  'ds.channels.confirm_remove': 'Remove this notification channel?',
  'ds.channels.type': 'Channel',
  'ds.channels.name': 'Name',
  'ds.channels.name_placeholder': 'e.g. Ops Teams channel',
  'ds.channels.url': 'Webhook URL',
  'ds.channels.url_hint': 'The incoming-webhook / Power Automate URL events are posted to.',
  'ds.channels.cancel': 'Cancel',
  'ds.channels.save': 'Save',
}

export const zhTW = {
  'ds.channels.title': '通知管道',
  'ds.channels.subtitle':
    '選擇您接收通知的方式。電子郵件預設開啟 — 可將其關閉，或新增您自己的 Teams、Slack 或 webhook。',
  'ds.channels.add': '新增管道',
  'ds.channels.email_title': '電子郵件',
  'ds.channels.inbox_note': '站內收件匣一律開啟。電子郵件及您新增的任何管道會額外傳送。',
  'ds.channels.channel.email': '電子郵件',
  'ds.channels.channel.teams': 'Microsoft Teams',
  'ds.channels.channel.slack': 'Slack',
  'ds.channels.channel.webhook': 'Webhook',
  'ds.channels.on': '已啟用',
  'ds.channels.off': '已停用',
  'ds.channels.enable': '啟用',
  'ds.channels.disable': '停用',
  'ds.channels.test': '測試',
  'ds.channels.edit': '編輯管道',
  'ds.channels.remove': '移除管道',
  'ds.channels.confirm_remove': '要移除此通知管道嗎？',
  'ds.channels.type': '管道',
  'ds.channels.name': '名稱',
  'ds.channels.name_placeholder': '例如：營運 Teams 頻道',
  'ds.channels.url': 'Webhook 網址',
  'ds.channels.url_hint': '事件將張貼至此 incoming-webhook／Power Automate 網址。',
  'ds.channels.cancel': '取消',
  'ds.channels.save': '儲存',
}
